import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=22840008&scoped=true"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"
import style0 from "./Highlight.vue?vue&type=style&index=0&id=22840008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22840008",
  null
  
)

export default component.exports